














import {Vue, Component} from 'vue-property-decorator';
import {VersionInterface} from "@/store/modules/globalInformationsModule";

@Component
export default class UpdateApp extends Vue {

  public refreshing: boolean = false;
  public registration: ServiceWorkerRegistration | null = null;
  public updateExists: boolean = false;


  created() {
    // Listen for swUpdated event
    document.addEventListener('swUpdated', (e) => {
      // @ts-ignore
      this.showNewUpdate(e.detail as ServiceWorkerRegistration);
    }, {once: true});

    // Refresh all open app tabs when a new service worker is installed.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!this.refreshing) {
        this.refreshing = true;
        window.location.reload();
      }
    });

    // Gestion de la version de Meetendo
    navigator.serviceWorker.addEventListener('message', (event: MessageEvent) => {
      const versionsInformations: VersionInterface = (event.data.hasOwnProperty('version')) ? event.data : false;
      if (versionsInformations) {
        this.$store.commit('updateVersionInformations', versionsInformations);
      }
    });

    navigator.serviceWorker.ready.then(registration => {
      registration?.active?.postMessage("versionsInfos");
    });
  }

  showNewUpdate(registration: ServiceWorkerRegistration) {
    this.registration = registration;
    this.updateExists = true;
  }

  refreshApp() {
    this.updateExists = false;
    if (this.registration?.waiting) {
      this.registration.waiting.postMessage('skipWaiting');
    } else {
      console.log(this.registration?.waiting, 'could not update the serviceWorker');
    }
  }

}

